<template>
  <div :class="['dict-entry-actions', layout === 'row' ? 'dict-entry-actions--row' : 'dict-entry-actions--column']">
    <router-link
      v-if="showEdit && entry.add_by_me"
      class="dict-entry-actions__item"
      :to="{ name: 'dictionary.entry.edit', params: { id: entry.id } }"
      v-b-tooltip.hover.top
      :title="$t('edit')"
      :aria-label="$t('edit')"
    >
      <i class="far fa-edit" aria-hidden="true"></i>
    </router-link>
    <button
      v-if="showAdd"
      type="button"
      class="dict-entry-actions__item dict-entry-actions__item--add"
      v-b-tooltip.hover.top
      :title="$t('add alternative')"
      :aria-label="$t('add alternative')"
      v-on="isLoggedIn() ? { click: () => $emit('add', entry.id) } : { click: () => $emit('register') }"
    >
      <i class="far fa-plus-square" aria-hidden="true"></i>
    </button>
    <button
      v-if="showFlag && !entry.flag_by_me"
      type="button"
      class="dict-entry-actions__item dict-entry-actions__item--report"
      v-b-tooltip.hover.top
      :title="$t('set flag \'inappropriate or copyright infringement\'')"
      :aria-label="$t('set flag \'inappropriate or copyright infringement\'')"
      v-on="isLoggedIn() ? { click: () => $emit('flag', entry.id) } : { click: () => $emit('register') }"
    >
      <i class="far fa-flag" aria-hidden="true"></i>
    </button>
    <button
      v-else-if="showFlag"
      type="button"
      class="dict-entry-actions__item dict-entry-actions__item--report dict-entry-actions__item--active"
      v-b-tooltip.hover.top
      :title="$t('flagged for \'inappropriate or copyright infringement\'')"
      :aria-label="$t('flagged for \'inappropriate or copyright infringement\'')"
      @click="$emit('flag', entry.id)"
    >
      <i class="fas fa-flag" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { modalMixin } from '../mixins/modalMixin'

export default {
  name: 'DictEntryActions',
  mixins: [modalMixin],
  props: {
    entry: { type: Object, required: true },
    layout: {
      type: String,
      default: 'column',
      validator: (value) => ['column', 'row'].includes(value)
    },
    showEdit: { type: Boolean, default: true },
    showAdd: { type: Boolean, default: true },
    showFlag: { type: Boolean, default: true }
  }
}
</script>
